// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Util from './lib/util';
import SearchFilter from "./modules/SearchFilter"
import VueRouter from "vue-router"

import $ from  "jquery";
import "bootstrap";
import "./main.scss"
import {jqueryPlugins} from "./lib/typeSelector";
import "./lib/type";


Vue.config.productionTip = false;
Vue.config.debug = true;

jqueryPlugins();
window.util = Util;
window.jQuery = $;
window.$ = $;

/**
 * General vue loader
 */
function init(){
  if ( typeof vueModule == 'undefined' || vueModule === ''){
    return;
  }

  let components = {};
  let module = require(`./modules/${window.vueModule}`).default;
  components[window.vueModule] = module;

  new Vue({
    el: '#app',
    components : components,
    template : `
    <div id="app">
        <${window.vueModule} />
    </div>
`
  });
}
init();

/**
 * load searchBar vue component
 */
function searchBar(){
  if ( typeof window.searchBar == 'undefined' ){
    return;
  }
  new Vue({
    el: '#searchFilter',
    components : {SearchFilter},
    template : `
    <div id="vueSearchFilter">
        <search-filter />
    </div>`
  });
}
searchBar();



// WEBPACK FOOTER //
// ./src/main.js